import React, { useEffect, useState } from 'react';

import Diversity2Icon from '@mui/icons-material/Diversity2Rounded';
import PeopleIcon from '@mui/icons-material/PeopleAltRounded';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendarRounded';
import SchoolIcon from '@mui/icons-material/SchoolRounded';

import PageContent from '../../components/PageContent';
import { ComingSoonMessage } from '../../components/PageLayout';
import Tabs from '../../components/Tabs';
import { useGetUserNotesQuery } from '../../services/users';
import { UserNote } from '../../services/users/types';
import { UserNoteType } from '../../types/common';
import useTab from '../../utils/react/hooks/useTab';

import EnrolmentsTab from './EnrolmentsTab';
import StudentsTab from './StudentsTab';

const TAB_OPTIONS = [
  {
    key: 'enrolments',
    label: 'Enrolments',
    icon: <PermContactCalendarIcon />,
  },
  {
    key: 'students',
    label: 'Students',
    icon: <SchoolIcon />,
  },
  {
    key: 'staff',
    label: 'Staff',
    icon: <PeopleIcon />,
  },
  {
    key: 'classes',
    label: 'Classes',
    icon: <Diversity2Icon />,
  },
];

const AdminFollowUpPage = () => {
  const [tab, setTab] = useTab({ default: TAB_OPTIONS[0].key });
  const [splitUserNotes, setSplitUserNotes] = useState<{ [userType: string]: UserNote[]}>({});

  const { data: userNotes } = useGetUserNotesQuery({});

  useEffect(() => {
    if (userNotes) {
      const leadNotes: UserNote[] = [];
      const studentNotes: UserNote[] = [];
      const staffNotes: UserNote[] = [];

      userNotes.data.forEach((note) => {
        if (note.userType === UserNoteType.Student) {
          studentNotes.push(note);
        } else if (note.userType === UserNoteType.Staff) {
          staffNotes.push(note);
        } else {
          leadNotes.push(note);
        }
      });

      setSplitUserNotes({
        leads: leadNotes,
        students: studentNotes,
        staff: staffNotes,
      });
    }
  }, [userNotes]);

  return (
    <PageContent>
      <>
        <Tabs options={TAB_OPTIONS} selectedKey={tab} onChange={(key) => setTab(key)} />
        {tab === 'enrolments' && <EnrolmentsTab userNotes={splitUserNotes?.leads} />}
        {tab === 'students' && <StudentsTab userNotes={splitUserNotes?.students} />}
        {tab === 'staff' && <ComingSoonMessage />}
        {tab === 'classes' && <ComingSoonMessage />}
      </>
    </PageContent>
  );
};
export default AdminFollowUpPage;
